import { Controller } from "stimulus";

export default class extends Controller {
    initialize() {
        super.initialize();
        const currentPath = window.location.pathname;
        if (currentPath.includes('/en')){
            let path = currentPath.replace(/^\/[a-z]{2}(\/|$)/, '/');
            window.history.pushState({}, '', path);
        }
    }

    connect() {
        const controller = this;
        try {
            this.initWeglot();

            Weglot.on("languageChanged", function(newLang, prevLang) {
                if (newLang === 'en') newLang = '';
                let languagePath = controller.languagePath(newLang)
                if(!languagePath) languagePath = '/'
                window.history.pushState({}, '', languagePath);
                if (swal.isVisible()){
                    controller.initWeglot();
                }
            });
        } catch (e) {
            console.error("Error initializing Weglot:", e);
        }
    }

    initWeglot() {
        Weglot.initialize({
            api_key: atob(window.WEGLOT_API_KEY),
            cache: true,
            switchers: [
                {
                    style: {
                        is_dropdown: true,
                        with_flags: false,
                    }
                }
            ]
        });
    }

    // Add language links
    addLanguageLink(language, path) {
        let link = document.querySelector(`link[rel="alternate"][hreflang="${language}"]`);
        if (link) {
            link.href = path;
        } else {
            link = document.createElement('link');
            link.rel = "alternate";
            link.hreflang = language;
            link.href = path;
            document.head.appendChild(link);
        }
    }

    languagePath(language, with_origin = false) {
        let origin = window.location.origin;
        const currentPath = window.location.pathname;
        let path = currentPath.replace(/^\/[a-z]{2}(\/|$)/, '/');
        path = path === '/' ? '' : path;

        if (with_origin && language)
            return `${origin}/${language}${path}`;
        else if (with_origin)
            return `${origin}${path}`;
        else if (language)
            return `/${language}${path}`;
        else
            return path;
    }
}
